export function getProviderInfo() {
  return {
    nameLine: "FyreCRM by OnFyre Marketing",
    addressLines: ["Riedlach 22", "68307 Mannheim"],
    phone: { href: "tel:062179903893", label: "062179903893" },
    email: { href: "mailto:info@onfyre.de", label: "info@onfyre.de" },
    websites: [
      { href: "https://www.onfyre.de", label: "www.onfyre.de" },
      { href: "https://www.fyreweb.de", label: "www.fyreweb.de" },
    ],
  };
}
